<template>
  <div class="login-template" theme>
    <div id="theme-login-control" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      path: 'user',
      parts: [
        {
          elem: '#theme-login-control',
          htmlFile: 'login'
        }
      ]
    }
  },
  mounted() {
    if (this.loggedInUser) {
      this.openLink('/')
    }
  }
}
</script>
